import { render, staticRenderFns } from "./comfirmBox.vue?vue&type=template&id=9f25e012&scoped=true&"
import script from "./comfirmBox.vue?vue&type=script&lang=js&"
export * from "./comfirmBox.vue?vue&type=script&lang=js&"
import style0 from "./comfirmBox.vue?vue&type=style&index=0&id=9f25e012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f25e012",
  null
  
)

export default component.exports